import { useAuth } from "../../../providers/auth";
import ExternalPendingOffers from "../externalView/pages/ExternalPendingOffers";
import AdminPendingJobOffers from "../parts/AdminPendingJobOffers";
import algoliasearch from "algoliasearch/lite";
import { InstantSearch } from "react-instantsearch-hooks-web";

const searchClient = (() => {
  if (!process.env.REACT_APP_ALGOLIA_APP_ID) {
    throw new Error(
      "REACT_APP_ALGOLIA_APP_ID environment variable not defined",
    );
  }
  if (!process.env.REACT_APP_ALGOLIA_API_KEY) {
    throw new Error(
      "REACT_APP_ALGOLIA_API_KEY environment variable not defined",
    );
  }

  return algoliasearch(
    process.env.REACT_APP_ALGOLIA_APP_ID,
    process.env.REACT_APP_ALGOLIA_API_KEY,
  );
})();

const PendingOffers = () => {
  const { userClaims } = useAuth();

  return (
    <div className="min-h-screen">
      <InstantSearch indexName="Offers" searchClient={searchClient}>
        {userClaims?.claims?.type === "A" ? <AdminPendingJobOffers /> : null}
        {userClaims?.claims?.type === "E" ? <ExternalPendingOffers /> : null}
      </InstantSearch>
    </div>
  );
};

export default PendingOffers;
